import React, { useEffect, useRef } from 'react';
import { wechatGenerateScheme } from "../../api";
import './style.scss';

// 新加坡「反正好玩」→ 八大洲小程序 新加坡专题页 落地页
// 点第 3 张按钮 → scheme 拉起小程序空白中转页（判新老：老用户直进专题页 / 新用户注册后回跳）
const MINI_PATH = "/pages/subject/k9x2m7hq/k9x2m7hq";

// 9 张切图，从上到下拼接；第 2 张（index 1）是「点击进入」按钮
const imgs = [
  "https://staticfile.badazhou.com/20260929/82d4f582832491b67c28e1ea2c09ea9e.jpg", // _01
  "https://staticfile.badazhou.com/20260929/02ef44ed5dcb42796bc22acdbc24d592.jpg", // _02 含按钮
  "https://staticfile.badazhou.com/20260929/855d10c17c53824aa5a569948a409a90.jpg", // _03
  "https://staticfile.badazhou.com/20260929/54363ca88be98413aa12150d1e81e77c.jpg", // _04
  "https://staticfile.badazhou.com/20260929/aac0ebe3a2bd2ec7a95185dac945296b.jpg", // _05
  "https://staticfile.badazhou.com/20260929/5e86658e8e3a3752c6196dbfd4f574ff.jpg", // _06
  "https://staticfile.badazhou.com/20260929/c90e59ac8bdd2bb07c93b03c5b41e8f4.jpg", // _07
  "https://staticfile.badazhou.com/20260929/3f0ed45f06d1b07a730ce75fbd9e94d8.jpg", // _08
  "https://staticfile.badazhou.com/20260929/c299079ab5a79979942c734eb5bf46e0.jpg", // _09
];

const BTN_INDEX = 1; // 「点击进入」按钮所在切图下标（第 2 张）

const Sn7k2x9m = () => {
  const schemeRef = useRef();

  useEffect(() => {
    // 提前生成跳小程序的 URL Scheme
    const randomNum = parseInt(Math.random() * 100000000, 10);
    wechatGenerateScheme({ path: MINI_PATH, query: `randomNum=${randomNum}` })
      .then((res) => { schemeRef.current = res.data; })
      .catch(() => {});
  }, []);

  const goToWxApp = () => {
    const scheme = schemeRef.current && schemeRef.current.scheme;
    if (scheme) {
      window.location.href = scheme;
    }
  };

  return (
    <div className="sn-container">
      {imgs.map((src, i) => (
        <img
          key={i}
          className="sn-img"
          src={src}
          alt=""
          onClick={i === BTN_INDEX ? goToWxApp : undefined}
          style={i === BTN_INDEX ? { cursor: 'pointer' } : undefined}
        />
      ))}
    </div>
  );
};

export default Sn7k2x9m;
